import axios from 'axios';

const httpSearchPrincipal = (payload) => {
  return axios.post('/api/v2/principal/search', payload);
};

export { httpSearchPrincipal };
